module.exports = __webpack_public_path__ + "img/Differentiation-LICA_GSE236681.129f11e0.png";